import React, { useState } from "react";
import Form from 'deltoid/core/Form';
import RadioButton from "../BaseComponents/RadioButton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { websiteDetailsActions } from "@store/ducks";

import { Row, Col, Container } from "deltoid/core/Blocks/BootstrapContainers";

const StatusForm = ({ submitWebsiteStatus }) => {
  const [selectedValue, setSelectedValue] = useState(false);

  const handleChange = (event) => {
    event.target.value === 'domain-active' ? setSelectedValue(true) : setSelectedValue(false);
  };

  const onWebsiteStatusSubmit = () => {
    submitWebsiteStatus(selectedValue ? "active" : "inactive");
  };

  return (
    <div className="domain-status-form">
      <RadioButton
        className='domain-inactive-radio'
        name="domain-inactive"
        value='domain-inactive'
        checked={!selectedValue}
        label='Website domain is NOT ACTIVE'
        onChange={handleChange}
      />
      <RadioButton
        className='domain-active-radio'
        name="domain-active"
        value="domain-active"
        checked={selectedValue}
        label='Website domain is ACTIVE'
        onChange={handleChange}
      />
      <Form.Button
        className='domain-status-submit-btn'
        onClick={onWebsiteStatusSubmit}
      >
        Confirm
      </Form.Button>
    </div>
  );
};

StatusForm.propTypes = {
  submitWebsiteStatus: PropTypes.func.isRequired,
};
StatusForm.defaultProps = {
  submitWebsiteStatus: () => { },
};

const mapDispatchToProps = (dispatch) => ({
  submitWebsiteStatus: (websiteStatus) =>
    dispatch(websiteDetailsActions.submitWebsiteStatus(websiteStatus)),
});
const mapStateToProps = (state) => ({
  websiteStatus: state.onboardingApp.websiteDetails.websiteStatus,
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusForm);
